module.exports = __webpack_public_path__ + "img/ust.4a084ab5.svg";